
import Attachment from "../../../components/drag_and_drop/Attachment/Attachment.vue";
import { loadingOverlay } from "vuetify-more-component";
import credit_card from "../../../components/shared/credit_card/credit_card.vue";
import { EncryptService } from "../../../utils/encrypthService";




export default {
    name: 'suscripcionTabs',
    components: { Attachment, loadingOverlay, credit_card },
    props: {
        esExtraordinaria: {
            type: Boolean,
            default: false
        },
        esSociedadAnonima: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            e1: 1,
            clientes_cargados: [],
            sociedades_cargadas: [],
            buscar: '',
            headers_clientes: [
                {
                    text: 'CUI/DPI',
                    align: 'start',
                    value: 'cui',
                },
                { text: 'NIT', value: 'nit' },
                { text: 'Primer Nombre', value: 'primerNombre' },
                { text: 'Segundo Nombre', value: 'segundoNombre' },
                { text: 'Primer Apellido', value: 'primerApellido' },
                { text: 'Segundo Apellido', value: 'segundoApellido' },
                { text: 'Apellido Casada', value: 'apellidoCasada' },
                { text: 'Contraseña', value: 'contrasenia' },
                { text: 'Fecha Nacimiento', value: 'fechaNacimiento' },
            ],
            headers_sociedades: [
                {
                    text: 'NIT',
                    align: 'start',
                    value: 'nit',
                },
                { text: 'Nombre Sociedad', value: 'nombreSociedad' },
                { text: 'Contraseña', value: 'contrasenia' },
                { text: 'Fecha Creación', value: 'fechaCreacion' },
            ],
            cargando_info: false,

            mostrarFormularioPago: false,

            usuario: null,
            suscripcion: null,

            requisitos: {
                precio_suscripcion: 100,
                nombre_suscripcion: "Suscripción Gestor",
                descripcion_suscripcion: "La suscripción es deacuerdo a la cantidad de clientes que se desean registrar",
                suscripcion_sugerida: null,
                total_clientes: 0,
                correo: null,
                otp: null,
                tarjeta: {
                    token: "",
                    client: null,
                    amount: null,
                    cvv: null,
                    aceptaTerminos: false
                },
                clientes: [],
                sociedades: [],
                info_cupon: {
                    id: null,
                    descuento: null,
                    precio_actual: null,
                    nuevo_precio: null,
                    tipo: null
                },

                cupon: null,
            },
            existe_repetidos: false,
            cupon: null,
            dialog_cupon: false,
            loading_cupon: false,
            loading_pago: false,

            validOTP: false,
            changeEmail: false,
            baseEmail: null,
        }
    },

    created() {
        // almacena en el sessionStorage el valor de la pestaña activa
        if (sessionStorage.getItem('activeTab') === null) {
            sessionStorage.setItem('activeTab', this.e1);
        }
        this.e1 = sessionStorage.getItem('activeTab');

        this.e1 = 1;
        sessionStorage.setItem('activeTab', this.e1);

    },

    watch:{
    "requisitos.correo"() {
      if (this.requisitos.correo != this.baseEmail) {
        this.changeEmail = true;
      } else {
        this.changeEmail = false;
      }
    },
    },

    methods: {

            regresarAPago(){
      this.e1 = 4;
    },

    continuarResumen() {
      this.e1 = 6;
    },

    async validarOtp() {
      try {

        // valida que el formulario sea correcto formOTP
        if (!this.$refs.formOTP.validate()) {
          this.$toast.warning("Por favor, complete todos los campos requeridos del formulario de OTP", { position: "top-center", timeout: 5000 });
          return;
        }

        this.loading_cupon = true;
        let r = await this.$store.state.services.usuarioService.validarOtp({ token: this.requisitos.otp});
        console.log(r.data);
        if(r.data.success){
          this.continuarResumen();
        }else{
          this.$toast.warning(r.data.message, { position: "top-center", timeout: 5000 });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading_cupon = false;
      }
    },

    async actualizarCorreoPrimeraVez() {
      try {
        this.loading_cupon = true;
        let r = await this.$store.state.services.usuarioService.actualizarCorreoPrimeraVez({nuevo_correo: this.requisitos.update_data_user.correo});
        console.log(r.data);
        if(r.data.success){
          this.$toast.success("Correo actualizado correctamente, ahora ingresa el código OTP que te hemos enviado al nuevo correo para validar el cambio", { position: "top-center", timeout: 5000 });
        }else{
          this.$toast.warning(r.data.message, { position: "top-center", timeout: 5000 });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading_cupon = false;
        this.changeEmail = false;
      }
    },

      async obtenerCorreoUsuario() {
      try {
        this.loading_cupon = true;
        let r = await this.$store.state.services.usuarioService.getCorreoUsuario();
        console.log("correo usuario", r.data.data);
        this.requisitos.correo = r.data.data.correo;
        this.baseEmail = r.data.data.correo;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener el correo del usuario")
      } finally {
        this.loading_cupon = false;
      }
    },


        descargarArchivo() {
            const link = document.createElement('a');
            link.href = 'docs/formato_carga_clientes.xlsx'; // Ruta relativa desde la raíz del servidor
            link.download = 'formato_carga_clientes.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            sessionStorage.setItem('activeTab', this.e1);
        },

        descargarArchivoSociedadesAnonimas() {
            const link = document.createElement('a');
            link.href = 'docs/formato_carga_sociedades_anonima.xlsx'; // Ruta relativa desde la raíz del servidor
            link.download = 'formato_carga_sociedades_anonima.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            sessionStorage.setItem('activeTab', this.e1);
        },

        clientesRetornados(obj) {
            console.log('CLIENTES RETORNADOS');
            let data = obj;
            console.log(data);
            this.procesarArchivo(data);
        },

        sociedadesRetornadas(sociedades) {
            console.log('SOCIEDADES RETORNADAS');

            let clientes_nuevos = sociedades.map(cliente => {
                // valida si el elmento del array contine los campos obligatorios
                if (cliente['NIT*'] && cliente['NOMBRE DE LA SOCIEDAD ANONIMA*'] && cliente['CONTRASEÑA AGENCIA VIRTUAL*'] && cliente['FECHA CREACIÓN DE LA SOCIEDAD ANONIMA*']) {
                    return {
                        nit: cliente['NIT*'],
                        nombreSociedad: cliente['NOMBRE DE LA SOCIEDAD ANONIMA*'],
                        contrasenia: cliente['CONTRASEÑA AGENCIA VIRTUAL*'],
                        fechaCreacion: cliente['FECHA CREACIÓN DE LA SOCIEDAD ANONIMA*']
                    };
                }
            });
            clientes_nuevos = clientes_nuevos.filter(cliente => cliente);
            this.sociedades_cargadas = clientes_nuevos;
        },

        procesarArchivo(clientes) {

            console.log('PROCESAR ARCHIVO');


            let clientes_nuevos = clientes.map(cliente => {
                // valida si el elmento del array contine los campos obligatorios
                if (cliente['CUI/DPI*'] && cliente['NIT*'] && cliente['PRIMER NOMBRE*'] && cliente['PRIMER APELLIDO*'] && cliente['CONTRASEÑA AGENCIA VIRTUAL*'] && cliente['FECHA NACIMIENTO*']) {
                    return {
                        cui: cliente['CUI/DPI*'],
                        nit: cliente['NIT*'],
                        primerNombre: cliente['PRIMER NOMBRE*'],
                        segundoNombre: cliente['SEGUNDO NOMBRE'] || '',
                        primerApellido: cliente['PRIMER APELLIDO*'],
                        segundoApellido: cliente['SEGUNDO APELLIDO'] || '',
                        apellidoCasada: cliente['APELLIDO CASADA'] || '',
                        contrasenia: cliente['CONTRASEÑA AGENCIA VIRTUAL*'],
                        fechaNacimiento: cliente['FECHA NACIMIENTO*']
                    };
                }
            });

            clientes_nuevos = clientes_nuevos.filter(cliente => cliente);
            this.clientes_cargados = clientes_nuevos;
            console.log(this.clientes_cargados);
        },

        cargarOtroArchivo() {
            this.clientes_cargados = [];
            this.existe_repetidos = false;
        },

        cargarOtroArchivoSociedades() {
            this.sociedades_cargadas = [];
            this.existe_repetidos = false;
        },

        omitirPaso1() {
            this.e1 = 2;
            sessionStorage.setItem('activeTab', this.e1);
        },

        async validarNitDpi() {
            try {
                console.log('VALIDAR NIT/DPI');
                this.cargando_info = true;
                this.existe_repetidos = false;
                const clientes = {
                    clientes: this.clientes_cargados
                }
                let r = await this.$store.state.services.gestoresService.validarNitDpi(clientes);
                console.log("clientes validados", r);
                this.cargando_info = false;

                let clientes_repetidos = r.data.data;

                if (clientes_repetidos.length > 0) {
                    this.existe_repetidos = true;
                    // por cada cliente repetido modifica el objeto a repetido->nit o dpi
                    this.clientes_cargados.forEach(cliente => {
                        clientes_repetidos.forEach(cliente_repetido => {
                            if (cliente.cui == cliente_repetido.cui && r.data.status == 6) {
                                cliente.cui = 'existente -' + cliente_repetido.cui;
                            }
                            if (cliente.nit == cliente_repetido.nit && r.data.status == 6) {
                                cliente.nit = 'existente -' + cliente_repetido.nit;
                            }
                            if (cliente.fechaNacimiento == cliente_repetido.fechaNacimiento && r.data.status == 7) {
                                cliente.fechaNacimiento = 'verificar -' + cliente_repetido.fechaNacimiento;
                            }

                        });
                    });
                    this.clientes_cargados = this.clientes_cargados;
                    this.$toast.warning("Existen clientes repetidos en el sistema o fechas incorrectas, por favor verifique los datos", { timeout: 6000 });
                } else if (clientes_repetidos.length == 0) {
                    this.e1 = 3;
                }
            } catch (error) {
                console.log(error);
                this.$toast.error("Ocurrió un error al validar el NIT/DPI");
                this.cargando_info = false;
            }
        },

        async continuarSinClientes() {
            this.e1 = 3;
            sessionStorage.setItem('activeTab', this.e1);
        },

        async validarSociedades() {
            try {
                console.log('VALIDAR SOCIEDADES');
                this.cargando_info = true;
                this.existe_repetidos = false;
                const sociedades = {
                    clientes: this.sociedades_cargadas
                }
                let r = await this.$store.state.services.gestoresService.validarNitDpi(sociedades);
                console.log("sociedades validadas", r);
                this.cargando_info = false;
                let sociedades_repetidas = r.data.data;
                if (sociedades_repetidas.length == 0) {
                    this.asginarSuscripcion();
                    return;
                }
                this.existe_repetidos = true;
            } catch (error) {
                console.log(error);
                this.$toast.error("Ocurrió un error al validar las sociedades");
                this.cargando_info = false;
            }
        },

        async continuarSinSociedades(){
            await this.asginarSuscripcion();
            this.e1 = this.esExtraordinaria ? 6 : 4; 
            sessionStorage.setItem('activeTab', this.e1);
        },

        async asginarSuscripcion() {

            console.log('ASIGNAR SUSCRIPCION');

            if (this.requisitos.cupon == null) {
                this.dialog_cupon = true;
              }
            
            let clientes_totales_agregados = 0;

            clientes_totales_agregados = this.clientes_cargados.length + this.sociedades_cargadas.length;
            

            const clientes = {
                clientes: clientes_totales_agregados,
            }
            try {
                this.cargarWidget();
                this.cargando_info = true;
                let r = await this.$store.state.services.gestoresService.asginarSuscripcion(clientes);
                console.log("suscripcion sugerida", r);
                this.requisitos.precio_suscripcion = r.data.data.precio;
                this.requisitos.nombre_suscripcion = r.data.data.categoria.nombre;
                this.requisitos.total_clientes = r.data.data.total_clientes;
                this.requisitos.descripcion_suscripcion = `
                La cantidad de clientes que se asocian a su cuenta en total ${this.requisitos.total_clientes} 
                incluida en el rango ${r.data.data.categoria.min} - ${r.data.data.categoria.max}
                `
                this.requisitos.suscripcion_sugerida = r.data.data.categoria.id;
                this.requisitos.clientes = this.clientes_cargados;
                this.requisitos.sociedades = this.sociedades_cargadas;

                console.log("es extraordinaria", this.esExtraordinaria);
                console.log("es sociedad anonima", this.esSociedadAnonima);
                
                if (this.esExtraordinaria) {
                    this.e1 =  6;
                    sessionStorage.setItem('activeTab', this.e1);
                    this.cargando_info = false;
                    return;
                }
                this.cargando_info = false;
                
                this.e1 = 4;
                sessionStorage.setItem('activeTab', this.e1);
            } catch (error) {
                this.$toast.error("Ocurrió un error al asignar la suscripción");
                this.cargando_info = false;
            }
        },

        cargarWidget() {
            sessionStorage.removeItem("CARD_INFO");
            sessionStorage.removeItem("CARD_REQUEST")

            $(document).ready(() => {
                $.ajax({

                    "type": "GET",

                    "url": "https://bacgateway.merchantprocess.net/SecureComponent/UIComponent/CreditCard",

                    "data": { "APIKey": $("#txtAPIKey").val(), "Token": $("#txtToken").val(), "Culture": "es" },

                    "success": function (jsonResponse) {

                        $("#creditcard-container").html(jsonResponse);

                        const boton = document.getElementById("card-ui-component-btn-confirm");
                        boton.innerHTML = "Verificar tarjeta";

                        $("#creditcard-container").slideDown(500);
                    }
                });
            });
        },

        verifica_tarjeta() {
            if (sessionStorage.getItem("CARD_REQUEST") != null) {
                let info = JSON.parse(atob(sessionStorage.getItem("CARD_REQUEST")))


                if (info.TokenDetails == null || info.TokenDetails == undefined) {
                    this.$toast.error("No es posible obtener los datos de la tarjeta, da clic en botón de regresar y vuelve a ingresar otra tarjeta", { position: "bottom-center", timeout: 5000 })
                    this.mostrarFormularioPago = false;
                    return;
                }

                this.$toast.success("Su tarjeta es válida , puede proceder a realizar el pago", { timeout: 5000 })
                console.log("esta es la información de mi tarjeta");

                this.mostrarFormularioPago = true;
            } else {
                this.mostrarFormularioPago = false;
                console.log("no llenado el formulario");
                this.$toast.info("Debe verificar la tarjeta de crédito con el banco emisor, presione el botón 'Verificar Tarjeta'", { position: "bottom-center", timeout: 8000 });

            }
        },


        async postPagoSuscripcionSale(data_card) {

            console.log('data card', data_card);
            let info = JSON.parse(atob(sessionStorage.getItem("CARD_REQUEST")))
            console.log("esta es la información de mi tarjeta");
            console.log(info);

            let info_tarjeta = {
                token: info.TokenDetails.AccountToken,
                numero: info.TokenDetails.CardNumber,
                client: info.TokenDetails.CardHolderName,
                amount: this.requisitos.precio_suscripcion,
                cvv: data_card.cardCvv,
                aceptaTerminos: data_card.checkbox
            }

            this.requisitos.tarjeta = info_tarjeta;

            console.log("info requisitos", this.requisitos);

             if(this.baseEmail == null){
                this.e1 = 5;
                await this.obtenerCorreoUsuario();
                }else{
                this.e1 = 6;
                }


            console.log("info tarjeta");
            console.log(info_tarjeta);
        },

        parseXmlToJson(xml) {
            const json = {};
            for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
                const key = res[1] || res[3];
                const value = res[2] && this.parseXmlToJson(res[2]);
                json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;

            }
            return json;
        },

        atras() {
            this.e1 = 2;
            sessionStorage.setItem('activeTab', this.e1);
            this.mostrarFormularioPago = false;
        },

        atrasPrevPago() {
            this.e1 = 3;
            this.mostrarFormularioPago = true;
            sessionStorage.setItem('activeTab', this.e1);
        },

        async almacenaSuscripcion() {
            if (this.esExtraordinaria) {
                this.alamcenaSuscripcionExtraordinaria();
            } else {
                this.alamcenaSuscripcionNormal();
            }
        },

        async alamcenaSuscripcionNormal() {
            try {
                console.log("ALMACENAR SUSCRIPCION");
                console.log(this.requisitos);
                this.cargando_info = true;
                this.encriptarContrasenias();
                let r = await this.$store.state.services.gestoresService.completarSuscripcion(this.requisitos);

                if (r.status != 200) {
                    this.$toast.error("Ocurrió un error al completar la suscripción");
                    this.cargando_info = false;
                    return;
                }
                this.cargando_info = false;
                this.completarSuscripcion();
                this.e1 = 4;
                sessionStorage.setItem('activeTab', this.e1);
            } catch (error) {
                this.$toast.error("Ocurrió un error al completar la suscripción");
                this.cargando_info = false;
            }
        },

        async alamcenaSuscripcionExtraordinaria() {
            console.log("ALMACENAR SUSCRIPCION EXTRAORDINARIA");
            try {
                this.cargando_info = true;

                this.encriptarContrasenias();

                console.log("this.requisitos", this.requisitos);
                
                let r = await this.$store.state.services.gestoresService.agregarClientesSuscripcion(this.requisitos);
                console.log("etxtraordinaria", r);
                if (r.status == 200) {
                    this.cargando_info = false;
                    await this.completarSuscripcionExtraordinaria();
                    this.e1 = 4;
                    sessionStorage.setItem('activeTab', this.e1);
                } else {
                    this.$toast.error("Ocurrió un error al completar la suscripción");
                    this.cargando_info = false;
                }

            } catch (error) {
                this.$toast.error("Ocurrió un error al completar la suscripción");
                console.log(error);
                
                this.cargando_info = false;
            }
        },

        async completarSuscripcion() {
            console.log("COMPLETAR SUSCRIPCION");
            await this.$toast.info("Suscripción completada con éxito", { timeout: 5000, position: "top-center" });
            sessionStorage.removeItem('activeTab');
            await this.$toast.success("Felicidades, tu suscripción fue un éxito!, inicia sesión por favor", { timeout: 5000, position: "top-center" });
            await this.enviarCorreoSuscripcion();
        },

        async completarSuscripcionExtraordinaria() {
            this.cargando_info = true;
            await this.enviarCorreoAdicionClientes();
            console.log("COMPLETAR SUSCRIPCION EXTRAORDINARIA");
            await this.$toast.info("Usuarios almacenado con éxito", { timeout: 5000, position: "top-center" });
            sessionStorage.removeItem('activeTab');
            await this.$toast.success("Felicidades, has sumado mas clientes!", { timeout: 5000, position: "top-center" });
            this.cargando_info = false;
        },

        async enviarCorreoSuscripcion() {
            try {
                console.log("enviar correo suscripcion");
                this.cargando_info = true;
                let data = {
                    "nombre_suscripcion": this.requisitos.nombre_suscripcion,
                    "cantidad_clientes": this.requisitos.total_clientes
                }
                let r = await this.$store.state.services.gestoresService.enviarCorreoSuscripcion(data);
                console.log(r);
                this.cargando_info = false;
                this.$router.push({ path: '/' });
            } catch (error) {
                this.$toast.error("Ocurrió un error al enviar el correo de suscripción");
            }
        },

        async enviarCorreoAdicionClientes() {
            try {
                console.log("enviar correo adicionar");
                let r = await this.$store.state.services.gestoresService.enviarCorreoAdicionClientes();
                console.log(r);
                this.$router.push({ path: '/gestor' });
            } catch (error) {
                this.$toast.error("Ocurrió un error al enviar el correo de adición de clientes");
            }
        },

        async validarCupon() {
            console.log("validar cupon");
            try {
                this.loading_cupon = true;
                const body = {
                    precio: this.requisitos.precio_suscripcion,
                    cupon: this.cupon
                }
                let r = await this.$store.state.services.usuarioService.canjearCupon(body);
                console.log("respuesta cupon");
                console.log(r);
                this.requisitos.cupon = null;

                if (r.data.success == false) {
                    this.$toast.error(r.data.message, { timeout: 5000 });
                    this.cupon = null;
                } else {
                    this.requisitos.precio_suscripcion = r.data.data.nuevo_precio;
                    this.requisitos.cupon = true;
                    this.requisitos.info_cupon.id = r.data.data.id;
                    this.requisitos.info_cupon.descuento = r.data.data.descuento;
                    this.requisitos.info_cupon.precio_actual = r.data.data.precio_actual;
                    this.requisitos.info_cupon.nuevo_precio = r.data.data.nuevo_precio;
                    this.requisitos.info_cupon.tipo = r.data.data.tipo;
                    this.$toast.success("Descuento aplicado en su suscripción", { timeout: 5000, position: "bottom-center" });
                    this.dialog_cupon = false;
                }

            } catch (error) {
                console.log(error);
                this.$toast.error("Error al validar el cupon o el cupon no existe", { timeout: 5000 });
            } finally {
                this.loading_cupon = false;
            }
        },

        omitirCupon() {
            console.log("omitir cupon");
            this.requisitos.cupon = null;
            this.dialog_cupon = false;
        },


        encriptarContrasenias() {
            const encryptService = new EncryptService();
            
            this.requisitos.clientes.forEach(cliente => {
                cliente.contrasenia = encryptService.encrypt(cliente.contrasenia);
            });
            this.requisitos.sociedades.forEach(sociedad => {
                sociedad.contrasenia = encryptService.encrypt(sociedad.contrasenia);
            });
        }

    }
}
